<template>
  <div class="configuration-forms-index">
    <vx-card title="Formulários">
      <div class="configuration-forms-content">
        <b-row>
          <b-col cols="12" md="8" lg="6">
            <select-suggestion
              label="Pessoa jurídica"
              column="company_name,trading_name,cnpj"
              model="LegalEntity"
              v-model="selectedLegalEntity"
              :appendClearOption="true"
              placeholderText="Digite o nome ou CNPJ da pessoa jurídica"
              :itemTextFormat="legalEntityItemTextFormat"
            />
          </b-col>
        </b-row>

        <p
          v-if="!legalEntityId"
          class="text-muted mb-0 mt-3"
        >
          Selecione uma pessoa jurídica para configurar os formulários.
        </p>

        <div
          v-if="legalEntityId && !legalEntityDataReady && !legalEntityLoadError"
          class="configuration-forms-after-filter"
        >
          <p class="text-muted mb-0">
            Carregando dados da pessoa jurídica…
          </p>
        </div>

        <div
          v-if="legalEntityId && legalEntityLoadError"
          class="configuration-forms-after-filter"
        >
          <p class="text-danger mb-0">
            Não foi possível carregar os dados desta pessoa jurídica. Selecione
            novamente ou tente mais tarde.
          </p>
        </div>

        <div
          v-if="legalEntityId && legalEntityDataReady"
          class="configuration-forms-after-filter configuration-forms-tabs-area"
        >
          <vs-tabs :key="formsTabsKey" :color="colorx">
            <vs-tab label="LGPD">
              <privacy-request
                :legalEntityId="legalEntityId"
                :legal-entity-record="loadedLegalEntity"
                :hide-back-button="true"
              />
            </vs-tab>
            <vs-tab label="Incidente">
              <incident
                :legalEntityId="legalEntityId"
                :legal-entity-record="loadedLegalEntity"
                :hide-back-button="true"
              />
            </vs-tab>
            <vs-tab label="Due Diligence">
              <due-diligence
                :legalEntityId="legalEntityId"
                :legal-entity-record="loadedLegalEntity"
                :hide-back-button="true"
              />
            </vs-tab>
            <vs-tab label="Intimidação Sistemática">
              <systematic-intimidation
                :legalEntityId="legalEntityId"
                :legal-entity-record="loadedLegalEntity"
                :hide-back-button="true"
              />
            </vs-tab>
            <vs-tab label="Formulário de Relato">
              <reporting-channel
                :legalEntityId="legalEntityId"
                :legal-entity-record="loadedLegalEntity"
                :hide-back-button="true"
              />
            </vs-tab>
          </vs-tabs>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import SelectSuggestion from '@/components/SelectSuggestion.vue'
import LegalEntityService from '@/services/api/LegalEntityService'
import PrivacyRequest from '@/views/apps/people/legal_entities/tabs/PrivacyRequest.vue'
import Incident from '@/views/apps/people/legal_entities/tabs/Incident.vue'
import DueDiligence from '@/views/apps/people/legal_entities/tabs/DueDiligence.vue'
import SystematicIntimidation from '@/views/apps/people/legal_entities/tabs/SystematicIntimidation.vue'
import ReportingChannel from '@/views/apps/people/legal_entities/tabs/ReportingChannel.vue'

export default {
  name: 'ConfigurationFormsIndex',
  components: {
    SelectSuggestion,
    PrivacyRequest,
    Incident,
    DueDiligence,
    SystematicIntimidation,
    ReportingChannel
  },
  data() {
    return {
      selectedLegalEntity: null,
      colorx: 'primary',
      legalEntityService: null,
      legalEntityLoadSeq: 0,
      legalEntityDataReady: false,
      legalEntityLoadError: false,
      loadedLegalEntity: null
    }
  },
  computed: {
    legalEntityId() {
      return this._.get(this.selectedLegalEntity, 'id', null) || null
    },
    formsTabsKey() {
      return this.legalEntityId ? `le-${this.legalEntityId}` : 'none'
    }
  },
  watch: {
    legalEntityId: {
      immediate: true,
      handler(id) {
        this.legalEntityDataReady = false
        this.legalEntityLoadError = false
        this.loadedLegalEntity = null
        if (!id) {
          return
        }
        this.syncLegalEntityFromApi(id)
      }
    }
  },
  beforeMount() {
    this.legalEntityService = LegalEntityService.build(this.$vs)
  },
  methods: {
    syncLegalEntityFromApi(id) {
      const seq = ++this.legalEntityLoadSeq
      this.legalEntityLoadError = false
      this.$vs.loading()
      this.legalEntityService
        .read(id)
        .then(
          legalEntity => {
            if (seq !== this.legalEntityLoadSeq || id !== this.legalEntityId) {
              return
            }
            this.loadedLegalEntity = legalEntity
            this.legalEntityDataReady = true
          },
          () => {
            if (seq !== this.legalEntityLoadSeq) {
              return
            }
            this.legalEntityLoadError = true
            this.$vs.notify({
              title: 'Erro',
              text: 'Não foi possível carregar os dados da pessoa jurídica.',
              color: 'danger',
              icon: 'alert-circle'
            })
          }
        )
        .finally(() => {
          if (seq === this.legalEntityLoadSeq) {
            this.$vs.loading.close()
          }
        })
    },
    legalEntityItemTextFormat(model) {
      let name = `${model.company_name} - ${model.trading_name}`
      const hasCnpj = !!model.cnpj
      if (hasCnpj) {
        name = `${name} ( ${this.cnpjFormat(model.cnpj)}) `
      }
      return name
    }
  }
}
</script>

<style lang="scss" scoped>
.configuration-forms-index {
  padding-bottom: 1rem;
}

.configuration-forms-content {
  padding-top: 0.25rem;
}

/* Separa visualmente o filtro do que vem abaixo (loading, erro ou abas), dentro do mesmo card */
.configuration-forms-after-filter {
  margin-top: 1.5rem;
  padding-top: 1.25rem;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.configuration-forms-tabs-area ::v-deep .con-slot-tabs {
  margin-top: 0.75rem;
}
</style>
